export enum ClientType {
  Individual = "Individual",
  Company = "Company",
}
